import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65acfaa0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbs" }
const _hoisted_2 = {
  key: 1,
  class: "breadcrumb-current"
}
const _hoisted_3 = {
  key: 2,
  class: "breadcrumb-separator"
}

import { computed } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  setup(__props) {

const route = useRoute();

const breadcrumbs = computed(() => {
	const pathArray = route.path.split("/").filter((p) => p);

	const breadcrumbList = pathArray.map((pathPart, index) => {
		const link = "/" + pathArray.slice(0, index + 1).join("/");
		return {
			name: beautifySlug(decodeURIComponent(pathPart)),
			link: link,
		};
	});

	return breadcrumbList;
});

// 👇 Den här funktionen fixar till sluggar till läsbara namn
function beautifySlug(slug: string) {
	return slug
		.split("-") // Dela på bindestreck
		.map((word) => {
			if (word.toLowerCase() === "d") return "d'"; // Hantera franska "d'"
			return capitalize(word);
		})
		.join(" ")
		.replace("D' ", "D'"); // Snygga till mellanrum efter D'
}

function capitalize(str: string) {
	if (!str) return "";
	return str.charAt(0).toUpperCase() + str.slice(1);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbs), (breadcrumb, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          (index !== _unref(breadcrumbs).length - 1)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: breadcrumb.link,
                class: "breadcrumb-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(breadcrumb.name), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(breadcrumb.name), 1)),
          (index !== _unref(breadcrumbs).length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "/"))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})